module.exports = __webpack_public_path__ + "img/_wifi.6e630b51.png";